<template>
  <div id="articles" class="pt-5 pb-5">
    <v-row class="pt-5" align="center" justify="center">
      <h1 class="display-2 pt-5">Medium Articles</h1>
    </v-row>
    <v-row class="mt-2" align="center" justify="center">
      <p class="headline">Check out our Medium Articles</p> </v-row
    ><v-container>
      <v-row class="mt-5" justify="center" align="center">
        <ArticleCard
          v-for="article in articles"
          :key="article.guid"
          :article="article"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import ArticleCard from "./ArticleCard";
export default {
  components: { ArticleCard },
  data() {
    return {
      articles: [],
    };
  },
  async created() {
    let { data } = await axios.get(
      "https://5o1hidfn19.execute-api.us-east-1.amazonaws.com/dev/articles"
    );

    this.articles = data.articles.splice(0, 9);
  },
};
</script>

<style>
.grey-bg-section {
  background-color: #f5f5f5;
  border-bottom: 1px solid #eeeeee;
}
</style>
